/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Caption_TranslatedInputs */

const cs_social_export_caption_translated = /** @type {(inputs: Social_Export_Caption_TranslatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popisek přeložen.`)
};

const en_social_export_caption_translated = /** @type {(inputs: Social_Export_Caption_TranslatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption translated.`)
};

/**
* | output |
* | --- |
* | "Caption translated." |
*
* @param {Social_Export_Caption_TranslatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_caption_translated = /** @type {((inputs?: Social_Export_Caption_TranslatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Caption_TranslatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_caption_translated(inputs)
	return cs_social_export_caption_translated(inputs)
});